export default __webpack_public_path__ + "static/media/view_details_doc.52e7aca8.svg";